//Importações do Node Modules
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//Importação da tela de Dados Iniciais PF
import Contrato from './contrato';

//Importações do store
// import {
//   changeDadosIniciaisPFValueForm
// } from '../../store/dadosIniciaisPF/actions';


//Get Ingformações do State do Reducer
const mapStateToProps = (state, nextState) => ({
  // dadosIniciaisPF: state.dadosIniciaisPFReducer,
});

//Ações efetuadas na action
const mapDispatchToProps = dispatch =>
  bindActionCreators({
    // changeDadosIniciaisPFValueForm
  }, dispatch);

//Exportação para o Dados Iniciais PF e Reducer
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contrato);